export default __webpack_public_path__ + "static/helix-bq-1-99efa6e0f97a75cfbaa07db19c52e17d.jpg";